<div class="container d-flex align-items justify-content-center align-items-center vh-100">
  <div class="row">
      <div class="col-12 text-center " *ngIf="pageSettings.type === 's' else failedBlock">
          <div>
           <img src="./assets/images/success.png" width="150" alt="">
           <h5 class="text-yl fi-text-bold fw-bold mt-3">Payment was successfull</h5>
           <p>You will be redirected to the main page. <br> You will receive the games passes via email shortly.</p>
           <i class="las la-spinner la-spin la-2x mt-3"></i>
          </div>
        
      </div>
      <ng-template #failedBlock>
        <div class="col-12 text-center ">
          <div>
           <img src="./assets/images/error.png" width="150" alt="">
           <h5 class="text-yl fi-text-bold fw-bold mt-3">Payment was unsuccessfull</h5>
           <p>You will be redirected to the main page.</p>
           <i class="las la-spinner la-spin la-2x mt-3"></i>
          </div>
        
      </div>
      </ng-template>
  </div>
</div>